exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropdown-menu > li > a {\r\n  cursor: pointer;\r\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5b5f5e94&file=Typeahead.vue!./~/vue-loader/lib/selector.js?type=style&index=0!./src/Typeahead.vue
 ** module id = 225
 ** module chunks = 0
 **/